<div class="sticker-icon-root"
  [ngClass]="{'small': small}">
  <mat-icon>{{icon}}</mat-icon>
  <span>
    <ng-content></ng-content>
  </span>
</div>
